// extracted by mini-css-extract-plugin
export default {"products":"pz-z","card":"qz-z","oosMessaging":"rz-z"};